import { FC } from 'react'
import { TwStyle } from 'twin.macro'
import {
  Activity,
  BookOpen,
  Clipboard,
  Heart,
  MessageCircle,
  Trello,
  TrendingUp,
  User,
  Users,
  UserCheck,
} from 'react-feather'
import { FeatherIconType } from '../types/icon'

type Props = {
  icon: FeatherIconType
  color?: string
  cssStyle?: TwStyle | TwStyle[]
}

const FeatherIcon: FC<Props> = ({ icon, color, cssStyle }) => {
  switch (icon) {
    case 'activity':
      return <Activity color={color} css={cssStyle} />
    case 'book open':
      return <BookOpen color={color} css={cssStyle} />
    case 'chat bubble':
      return <MessageCircle color={color} css={cssStyle} />
    case 'clipboard':
      return <Clipboard color={color} css={cssStyle} />
    case 'heart':
      return <Heart color={color} css={cssStyle} />
    case 'trello':
      return <Trello color={color} css={cssStyle} />
    case 'trending up':
      return <TrendingUp color={color} css={cssStyle} />
    case 'user':
      return <User color={color} css={cssStyle} />
    case 'users':
      return <Users color={color} css={cssStyle} />
    case 'user check':
      return <UserCheck color={color} css={cssStyle} />
  }
}

export default FeatherIcon
